import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';

const NormalSpinner = ({ label = 'Please wait...', size = 'xl', thickness = '4px', color = 'brand.red.800', mt = "0" }) => (
  <Box m="auto" textAlign="center">
    <Spinner size={size} thickness={thickness} color={color} label={label} mt={mt} speed="0.65s" />
  </Box>
);

export default NormalSpinner;
